import angular from "angular";
import UpcomingTasks from '../../modules/workflow/task/UpcomingTasks';
import "./charts";
import "./SnapshotService";
import "./OverviewMapController";
import "./SnapshotController";

angular.module('clientDashboardApp').value('UpcomingTasks', UpcomingTasks)

